<template>
<div>
    <div v-show="!isEditing">
        <div>
            <div class="card-header">
                <p class="card-header-title">{{ data.firstName }} {{ data.lastName }} ({{ data.email }})</p>
            </div>
            <footer class="card-footer">
                <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
                <a href="#" class="card-footer-item" v-on:click="deleteData(data)">Delete</a>
                <a href="#" class="card-footer-item" v-on:click="resetPassword(data)">Reset Password</a>
            </footer>
        </div>
    </div>

    <div v-show="isEditing">        
        <div class="card-header">
            <p class="card-header-title">Edit</p>
        </div>
        <div class="card-content">
            <div class="content">
                <div class="field">
                    <input class="input is-success" type="text" placeholder="First Name" v-model="data.firstName">
                </div>
                <div class="field">
                    <input class="input" type="text" placeholder="Last Name" v-model="data.lastName">
                </div>
                <div class="field">
                    <input class="input is-success" type="text" placeholder="E-mail" v-model="data.email">
                </div>
                <div class="field">
                    <b-radio v-model="data.status" native-value="1">
                        Active
                    </b-radio>
                    <b-radio v-model="data.status" native-value="0">
                        Inactive
                    </b-radio>
                </div>
                <div class="field">
                    <button class='button is-primary' v-on:click="updateData(data)">Update</button>
                    <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    props: ['data'],
    components:{
    },
    data() {
        return {
            listTeachers: [{
                _id: '',
                firstName: ''
            }],
            level: '',
            name: '',
            teachers: [],
            status: 1,
            isEditing: false
        };
    },
    created() {
    },
    methods: {
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        resetPassword(data) {
            this.$emit('reset-password', data);
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data) {
            this.$emit('update-data', data);
            this.isEditing = false;
        }
    },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Manage/Teachers/DataView.vue